import { Component, OnInit } from '@angular/core';

export interface ISection {
  id: string,
  articles: Array<{
    translationId: string,
  }>
}

export interface ITranslation {
  id: string,
  lang: string,
  type: string,
  markdown: string,
}

@Component({
  selector: 'create-articles',
  templateUrl: './create-articles.component.html',
  styleUrls: ['./create-articles.component.scss']
})
export class CreateArticlesComponent implements OnInit {

  sections:ISection[] = [];
  articles:ITranslation[] = [];
  translations:ITranslation[] = [];

  section: ISection;
  article:ITranslation;
  translation:ITranslation;

  constructor(
  ) { }

  ngOnInit() {


  }

}
